<template lang="pug">
  carousel.steps-carousel(
    v-if="['mobile', 'tablet'].includes($mq)"
    :slides-to-show="$mq === 'mobile' ? 1 : 2.2"
    :center-mode="true"
    :infinite="true"
    :dots="true"
  )
    slide(
      v-for="(step, index) in steps"
      :key="index"
    )
      subscription-step(
        :step="step"
        :index="index"
      )
  .subscription-steps(
    v-else
  )
    subscription-step(
      v-for="(step, index) in steps"
      :key="index"
      :step="step"
      :index="index"
    )
</template>

<script>
  import Carousel from 'scripts/components/basic/Carousel.vue';
  import Slide from 'scripts/components/basic/Slide.vue';
  import SubscriptionStep from 'scripts/components/basic/SubscriptionStep.vue';

  export default {
    name: 'SubscriptionSteps',
    props: {
      steps: Array,
    },
    components: { Carousel, Slide, SubscriptionStep },
  };
</script>

<style lang="scss" scoped>
  .subscription-steps {
    margin: auto;
    max-width: 935px;
    display: flex;

    .subscription-step {
      flex-basis: 0;
      flex-grow: 1;
    }

    .carousel__dots {
      margin-top: 15px;
    }
  }
</style>
